import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { GlassmorphismContainer } from "../styled/shared/Glassmorphism";
import DockerCard from "./DockerCard";
import { getTaskList } from "../../api/ProjectAPI";
import TileViewerTab from "./TileViewerTab";
import {
  InnerScrollContainer,
  ToggleButtonContainer,
} from "../styled/potree/PotreeControl.styles";
import AreaGenerate from "./AreaGenerate";
import AreaSelect from "./AreaSelect";
import {
  useAreaGenerateStore,
  useCesiumStore,
  usePointStore,
} from "../../Store/store";
import { useParams } from "react-router-dom";

import ImageProviderDropdown from "./ImageProviderDropdown";
import HideMenuButton from "../layout/HideMenuButton";
import useIsMobile from "../../hooks/useIsMobile";

const ControlDockContainer = styled(GlassmorphismContainer)`
  /* overflow: auto; */
  position: absolute;
  top: 50%;
  transition-duration: 500ms;
  transform: translateY(-50%);
  right: 20px;
  width: 370px;
  height: 80%;
  /* padding: 20px; */
  /* box-sizing: border-box; */
  color: #fff;

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  &.hidden {
    /* right: -370px; */
    right: 0;
    transform: translateY(-50%) translateX(100%);
  }
  @media (max-width: 600px) {
    top: auto;
    bottom: 0;
    left: 50%;
    transform: translateY(0%) translateX(-50%);
    width: 98%;
    max-width: 370px;

    &.hidden {
      transform: translateY(80%) translateX(-50%);
    }
  }
`;

export default function ControlDock() {
  const isMobile = useIsMobile(600);
  // const [toggleButton, setToggleButton] = useState("tileViewer");
  const [taskList, setTaskList] = useState([]);
  const [isHidden, setIsHidden] = useState(true);
  const { clearAllPoints, toggleButton, setToggleButton } = useCesiumStore();
  const { projectId } = usePointStore();

  useEffect(() => {
    const fetchTaskList = async (projectId) => {
      const response = await getTaskList(projectId);
      setTaskList(response);
    };
    if (projectId) {
      fetchTaskList(projectId);
    }
  }, []);

  // 태스크 리스트 초기화
  useEffect(() => {
    if (projectId && clearAllPoints) {
      clearAllPoints();
    }
  }, [toggleButton, projectId, clearAllPoints]);

  const handleToggleButton = (mode) => {
    if (mode === "tileViewer") {
      setToggleButton("tileViewer");
    } else if (mode === "areaGenerate") {
      setToggleButton("areaGenerate");
    } else if (mode === "areaSelect") {
      setToggleButton("areaSelect");
    }
  };

  return (
    <ControlDockContainer className={isHidden ? "hidden" : ""}>
      <HideMenuButton isHidden={isHidden} setIsHidden={setIsHidden} />

      <InnerScrollContainer>
        <ToggleButtonContainer>
          {projectId && (
            <button
              onClick={() => handleToggleButton("tileViewer")}
              className={toggleButton === "tileViewer" ? "active" : ""}
            >
              3D 뷰어
            </button>
          )}
          <button
            onClick={() => handleToggleButton("areaGenerate")}
            className={toggleButton === "areaGenerate" ? "active" : ""}
          >
            영역 지정
          </button>
          <button
            onClick={() => handleToggleButton("areaSelect")}
            className={toggleButton === "areaSelect" ? "active" : ""}
          >
            영역 선택
          </button>
        </ToggleButtonContainer>

        {/* 이미지 제공자 선택 버튼들 */}

        {toggleButton === "tileViewer" ? (
          <TileViewerTab taskList={taskList} />
        ) : toggleButton === "areaGenerate" ? (
          <>
            <ImageProviderDropdown />
            <AreaGenerate />
          </>
        ) : toggleButton === "areaSelect" ? (
          <AreaSelect />
        ) : null}
      </InnerScrollContainer>
    </ControlDockContainer>
  );
}
